<template>
  <div class="row">
<!--    <audit-header :audit="audit" />-->
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            Auditor Assignment
          </h4>
          <h6 class="card-subtitle">
            Assign the auditors to this audit from your organization.
          </h6>
        </div>
        <form class="form-horizontal" @submit.prevent="handleSubmit">
          <div class="form-group row">
            <label class="col-sm-3 text-right control-label col-form-label" for="auditors">Auditor</label>
            <div class="col-sm-6">
              <multiselect id="auditors" v-model="selectedAuditor" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('auditors')}" :clear-on-select="true" :close-on-select="true" :disabled="!saveShow" :hide-selected="false" :internal-search="false" :multiple="false" :options="auditorList" :preselect-first="false" :preserve-search="true" :searchable="false" class="form-control" label="email" name="auditors" placeholder="Select Auditor" track-by="id">
                <template slot="singleLabel" slot-scope="props">
                  {{ props.option.name }}
                </template>
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <h5>
                      {{ props.option.name }}
                      <br><small class="form-text">{{ props.option.public_key | hex_format(10, '....') }}</small>
                    </h5>
                    <span style="font-style: italic">
                      {{ props.option.description }}
                    </span>
                  </div>
                </template>
              </multiselect>
              <div v-if="submitted && errors.has('auditors')" class="invalid-feedback">
                {{
                  errors.first('auditors') }}
              </div>
            </div>
            <div class="col-sm-3">
              <button class="btn btn-group-lg waves-effect waves-light btn-outline-success">
                Save
              </button>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 text-right control-label col-form-label" for="comments">Comments </label>
            <div class="col-sm-6">
              <input id="comments" v-model="comments" class="form-control" name="comments" placeholder="Comments" type="text">
              <h4 class="text-muted text-left font-14 m-t-20">
                * N.B.: Select auditor from the dropdown to
                assign for the audit. or <router-link :to="{ name: 'new-address-book-entry'}" class="text-info m-l-5">
                  <b>Click Here</b>
                </router-link> to enter new Auditor into Address Book
              </h4>
            </div>
          </div>
        </form>
      </div>
    </div>
    <proposal-stat v-if="proposal_id" :proposal_id="proposal_id" />
  </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import EventBus from '@/event-bus';
import ProposalStat from '@/components/protected/common/ProposalStat.vue';
import {apiMixin} from '@/utils/api-mixin';

export default {
  name: 'AuditorAssignmentTab',
  components: { ProposalStat, Multiselect },
  mixins: [apiMixin('audit')],
  props: ['auditId'],
  data() {
    return {
      audit: null,
      current_user_role: null,
      status: null,
      auditorList: [],
      auditors: [],
      assignee: [],
      submitted: false,
      saveShow: true,
      optionSelected: {},
      selectedAuditor: null,
      tv_audit: null,
      comments: null,
      proposal_id: null
    };
  },
  computed: {
    ...mapGetters(['currentUser', 'activeGroup'])
  },
  beforeMount() {
    this.init();
  },
  methods: {
    async init() {
      await this.getAuditById(this.auditId);
      await this.getAuditors();
    },
    async getAuditById(auditId) {
      try {
        EventBus.$emit('showBlockUI');
        const reply = await this.$api.get('/audits/' + auditId);
        this.audit = reply.data;
        // this.audit.auditor_org = this.auditors.find(a => a.pub_key === reply.data.auditor);
        // this.audit.audit_creator = this.auditors.find(a => a.pub_key === reply.data.created_by);
        EventBus.$emit('auditStatus', this.audit.status);
      } catch (e) {
        console.error(e);
      } finally {
        EventBus.$emit('hideBlockUI');
      }
    },
    async assignAuditor() {
      // eslint-disable-next-line no-unused-vars
      let isProposal = false;
      if (this.activeGroup && this.activeGroup.threshold > 1) {
        isProposal = true;
      }
      await this.callApi('loader', isProposal, 'Audit accepted', async () => {
        await this.$api.patch(`/audits/${this.auditId}/auditors`, {
          field_auditors: this.selectedAuditor.public_key,
          comments: this.comments
        });
      });
      if(isProposal){
        this.$router.push({name: 'proposals'});
      }
      await this.$parent.getAuditById(this.auditId);
    },
    async getAuditors() {
      this.auditors = [];
      try {
        this.auditorList = (await this.$accounts.get('addressbook/user?address_type=Group')).data;
      } catch (e) {
        console.error(e);
      }
    },
    handleSubmit() {
      this.submitted = true;
      this.$validator.validate()
        .then(valid => {
          if (valid) {
            this.assignAuditor();
          }
        });
    }

  }
}
</script>

<style scoped>
</style>
